
import React from 'react';
import BootstrapSwitchButton from 'bootstrap-switch-button-react'

const fan_switch = (props) => {
	
	return (
		<div style={{"marginTop": 10}}>
        	<BootstrapSwitchButton
			    checked={props.fan_state}
			    onlabel='Fan On'
			    offlabel='Fan Off'
			    width='175'
			    onChange={props.onChange}
			/>
        </div>
	);
}

export default fan_switch;
